"use client";
import React, { createContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validateAndFetchToken } from "./actions/tokenService";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.config.initToken);

  useEffect(() => {
    dispatch(validateAndFetchToken());
  }, [dispatch]);

  return (
    <AuthContext.Provider value={{ token }}>{children}</AuthContext.Provider>
  );
};

export default AuthContext;
